import {FormattedMessage} from 'react-intl';
import React from 'react';

const LocationsHeader = () =>
    <section className='locations-header'>
        <span>
            <FormattedMessage id='ACCOUNT'/>
        </span>
        <span>
            <FormattedMessage id='CLAIMS'/>
        </span>
        <span>
            <FormattedMessage id='RECOVERY'/>
        </span>
        <span>
            <FormattedMessage id='TOTAL_UNPAID'/>
        </span>
    </section>;

LocationsHeader.displayName = 'LocationsHeader';

export default LocationsHeader;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-main/locations-accordion/locations-header.js